import React, {useState} from "react";
import "./ForInfluencersVisuals.scss";
import { imageCards, VisualTabKey, ImageCard } from './content';
import { Image } from "antd";
import Icon from "@ant-design/icons";
import { ReactComponent as ImagePlaceholder } from "assets/icons/image-placeholder.svg";
import DownloadBtn from "../../DownloadBtn";

export const ForInfluencersVisuals: React.FC = React.memo(() => {
    const VISUAL_TAB_KEY = {
        LOGOS: 'logos',
        ART: 'art',
        GAMEPLAY_SCREENSHOTS: 'gameplay_screenshots',
    } as const;

    const [activeVisualTabKey, setActiveVisualTabKey] =
        useState<VisualTabKey>(VISUAL_TAB_KEY.LOGOS);

    const [clickedSrc, setClickedSrc] = useState<string | null>(null);

    const handleMouseDown = (src: string) => {
        setClickedSrc(src);
    };

    return (
        <div className="visuals">
            <div className="visual-tabs">
                <button
                    className={'visual-tab left' + ' ' + (activeVisualTabKey === VISUAL_TAB_KEY.LOGOS ? 'active' : '')}
                    onClick={() => {setActiveVisualTabKey(VISUAL_TAB_KEY.LOGOS)}}
                >
                    <span className="tab-text">Logos</span>
                </button>
                <button
                    className={'visual-tab middle' + ' ' + (activeVisualTabKey === VISUAL_TAB_KEY.ART ? 'active' : '')}
                    onClick={() => {setActiveVisualTabKey(VISUAL_TAB_KEY.ART)}}
                >
                    <span className="tab-text">Art</span>
                </button>
                <button
                    className={'visual-tab right' + ' ' + (activeVisualTabKey === VISUAL_TAB_KEY.GAMEPLAY_SCREENSHOTS ? 'active' : '')}
                    onClick={() => {setActiveVisualTabKey(VISUAL_TAB_KEY.GAMEPLAY_SCREENSHOTS)}}
                >
                    <span className="tab-text">Gameplay Screenshots</span>
                </button>
            </div>
            <div className="image-list">
                {imageCards[activeVisualTabKey].map((card: ImageCard) => {
                    return (
                        <div className="visual-card" key={card.src}>
                            <div
                                className={`visual-card-image ${clickedSrc === card.src ? "clicked" : ""}`}
                                onMouseDown={() => handleMouseDown(card.src)}
                                onMouseUp={() => setClickedSrc(null)}
                            >
                                <Image
                                    src={card.preview}
                                    preview={{
                                        src: card.src,
                                        mask: (
                                            <Icon
                                                component={ImagePlaceholder}
                                                style={{ fontSize: "4rem" }}
                                            />
                                        ),
                                    }}
                                />
                            </div>
                            <div className="visual-card-title">{card.title}</div>
                            <DownloadBtn href={card.src} filename={card.title} />
                        </div>
                    );
                })}
            </div>
        </div>
    )
});